import {ModuleWithProviders, NgModule} from '@angular/core';
import {LAYOUT_SERVICES, ModalComponents} from './index';
import {SharedModule} from '../shared/shared.module';
import {TranslateModule} from '@ngx-translate/core';
import {NavigationModule} from "@ispm/navigation/navigation.module";
import {CommonModule} from "@angular/common";

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    NavigationModule
  ],
  declarations: [...ModalComponents],
  exports: [...ModalComponents]
})
export class LayoutModule {
  static forRoot(): ModuleWithProviders<LayoutModule> {
    return {
      ngModule: LayoutModule,
      providers: [
        ...LAYOUT_SERVICES
      ]
    };
  }
}

